import { ApiError } from "./ApiError";

// A 4xx cannot succeed on retry; timeouts, 5xx and transport failures can.
export const isClientError = (error: unknown): boolean =>
  error instanceof ApiError && error.errorClass === "4xx";
